import React from 'react';

const VehicleFeatureTag = ({ children, icon, className = "" }) => {
  return (
    <div className={`inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-3 py-1.5 rounded-full text-sm font-medium ${className}`}>
      {icon && <span className="text-blue-600">{icon}</span>}
      <span>{children}</span>
    </div>
  );
};

export default VehicleFeatureTag;
